var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.0812 2.25208C12.3719 1.53806 11.5283 0.971471 10.599 0.584952C9.66972 0.198434 8.67313 -0.000368766 7.66667 5.13513e-07C5.63334 5.13513e-07 3.68329 0.807736 2.24551 2.24552C0.807736 3.68329 0 5.63334 0 7.66667C0 9.69999 0.807736 11.65 2.24551 13.0878C3.68329 14.5256 5.63334 15.3333 7.66667 15.3333C11.2413 15.3333 14.2217 12.8896 15.0746 9.58333H13.0812C12.6865 10.7041 11.9536 11.6748 10.9838 12.3614C10.014 13.048 8.85495 13.4167 7.66667 13.4167C6.14167 13.4167 4.67914 12.8109 3.6008 11.7325C2.52247 10.6542 1.91667 9.19166 1.91667 7.66667C1.91667 6.14167 2.52247 4.67914 3.6008 3.6008C4.67914 2.52247 6.14167 1.91667 7.66667 1.91667C9.2575 1.91667 10.6758 2.57792 11.7108 3.6225L8.625 6.70833H15.3333V5.13513e-07L13.0812 2.25208Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refresh-icon.5f19bb817f61263b02cb5c913d68d9f7.svg";
export { ForwardRef as ReactComponent };